















// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import ForgotPassword from "@/components/auth/member/forgotPassword.vue";
import ForgotPasswordConfirm from "@/components/auth/member/forgotPasswordConfirm.vue";

@Component({
  name: "ForgotPasswordPage",
  components: {
    ForgotPassword,
    ForgotPasswordConfirm,
  },
})
export default class ForgotPasswordPage extends Vue {
  public isComplete = false;
  public email = "";
  public isShow = false;

  public switchConfirm(email: string) {
    this.isComplete = true;
    this.email = email;
  }

  public show() {
    this.isShow = true;
  }

  public hide() {
    this.isShow = false;
  }
}
